module.exports = __webpack_public_path__ + "files/7c76ceb98c1acf6346f5d058bc5944a7.png";